import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteBankAccount } from '../../../../actions';

const BankAccountDeleteButton = ({
  dispatchDeleteBanAccount,
  bankAccountId,
  disabled,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onClickDelete = () => dispatchDeleteBanAccount({ bankAccountId });

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  return (
    <>
      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDelete}
        onClickCancel={closeModal}
      />
      <Button color="danger" onClick={openModal} disabled={disabled}>
        <i className="fa fa-trash-o" /> Eliminar
      </Button>
    </>
  );
};

BankAccountDeleteButton.propTypes = {
  dispatchDeleteBanAccount: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  bankAccountId: PropTypes.number.isRequired,
};

BankAccountDeleteButton.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  dispatchDeleteBanAccount: deleteBankAccount,
};

export default connect(null, mapDispatchToProps)(BankAccountDeleteButton);
